import mermaid from 'mermaid';

function isDarkMode() {
	const root = document.documentElement;
	if (root.classList.contains('dark')) return true;
	if (root.classList.contains('light')) return false;
	return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

const blocks = [...document.querySelectorAll('pre.mermaid')];
for (const el of blocks) el.dataset.src = el.textContent;

async function render() {
	for (const el of blocks) {
		el.removeAttribute('data-processed');
		el.textContent = el.dataset.src;
	}
	mermaid.initialize({
		startOnLoad: false,
		theme: isDarkMode() ? 'dark' : 'default',
	});
	await mermaid.run({ nodes: blocks });
}

await render();

// react to OS preference changes while in 'system' mode
window
	.matchMedia('(prefers-color-scheme: dark)')
	.addEventListener('change', render);

// react to explicit mode toggles (theme picker adds/removes .dark/.light on <html>)
new MutationObserver(render).observe(document.documentElement, {
	attributes: true,
	attributeFilter: ['class'],
});
